import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'split'
})
export class SplitPipe implements PipeTransform {
    transform(val: any, params: string[]): string[] {
        const [result] = val.split(/\.(?=[^\.]+$)/);
        return result;
    }
}